import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SimXAgreement } from '../../../shared/models/entities/simx-agreement.model';
import { SimXInstitutionUser } from '../../../shared/models/entities/simx-institution-user.model';
import { SimXUser } from '../../../shared/models/entities/simx-user.model';
import { State } from './authentication-store.state';

const getIsAcceptingAgreement = (state: State): boolean =>
  state.isAcceptingAgreement;
const getIsAuthenticated = (state: State): boolean => state.isAuthenticated;
const getIsAuthenticating = (state: State): boolean => state.isAuthenticating;
const getIsDeletingUserSignedAgreement = (
  state: State,
): { userAgreementId: string } | null => state.isDeletingUserSignedAgreement;
const getIsLoggedIn = (state: State): boolean => state.isLoggedIn;
const getIsLoggingIn = (state: State): boolean => state.isLoggingIn;
const getIsLoggingOut = (state: State): boolean => state.isLoggingOut;
const getToken = (state: State): string => state.token;
const getUnsignedAgreements = (state: State): Array<SimXAgreement> =>
  state.unsignedAgreements;
const getUser = (state: State): SimXUser | null => state.user;
const getUserId = (state: State): string => state.user?.id || null;
const getUserName = (state: State): string => state.user?.name || null;
const getUserInstitutions = (state: State): Array<SimXInstitutionUser> =>
  state.user?.institutionUsers || [];

export const selectAuthenticationState =
  createFeatureSelector<State>('authentication');

export const selectIsAcceptingAgreement = createSelector(
  selectAuthenticationState,
  getIsAcceptingAgreement,
);
export const selectIsAuthenticated = createSelector(
  selectAuthenticationState,
  getIsAuthenticated,
);
export const selectIsAuthenticating = createSelector(
  selectAuthenticationState,
  getIsAuthenticating,
);
export const selectIsDeletingUserSignedAgreement = createSelector(
  selectAuthenticationState,
  getIsDeletingUserSignedAgreement,
);
export const selectIsLoggedIn = createSelector(
  selectAuthenticationState,
  getIsLoggedIn,
);
export const selectIsLoggingIn = createSelector(
  selectAuthenticationState,
  getIsLoggingIn,
);
export const selectIsLoggingOut = createSelector(
  selectAuthenticationState,
  getIsLoggingOut,
);
export const selectToken = createSelector(selectAuthenticationState, getToken);
export const selectUnsignedAgreements = createSelector(
  selectAuthenticationState,
  getUnsignedAgreements,
);
export const selectUser = createSelector(selectAuthenticationState, getUser);
export const selectUserId = createSelector(
  selectAuthenticationState,
  getUserId,
);
export const selectUserName = createSelector(
  selectAuthenticationState,
  getUserName,
);
export const selectUserInstitutions = createSelector(
  selectAuthenticationState,
  getUserInstitutions,
);
